import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector
} from '@angular/core';

import {ShareTooltipComponent} from '../shared/share-tooltip/share-tooltip.component';

@Injectable({
  providedIn: 'root'
})
export class ShareTooltipService {

  tooltipInstance: ComponentRef<ShareTooltipComponent>;
  isOpened = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private appRef: ApplicationRef,
              private injector: Injector) {
  }

  showShareTooltip(top, left, url) {
    if (this.isOpened) {
      this.closeShareTooltip();
      this.showShareTooltip(top, left, url);
    } else {
      this.tooltipInstance = this.componentFactoryResolver
        .resolveComponentFactory(ShareTooltipComponent)
        .create(this.injector);

      this.tooltipInstance.instance.config = {top, left};
      this.tooltipInstance.instance.url = url;

      this.appRef.attachView(this.tooltipInstance.hostView);

      const domElement = (this.tooltipInstance.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;

      document.body.appendChild(domElement);
      this.isOpened = true;
    }
  }

  closeShareTooltip() {
    if (this.isOpened) {
      this.appRef.detachView(this.tooltipInstance.hostView);
      this.tooltipInstance.destroy();
      this.isOpened = false;
    }
  }
}
